import Parcel from '../../Parcel';
import ResponseResult from '../../../../bootstrap/api/ResponseResult';
import ResponseError from '../../../../bootstrap/api/ResponseError';

export default class CourseCreateParcel extends Parcel {
    constructor(values) {
        super();

        this.setRequestMethod('POST');
        this.setEndpoint('/api/course/create');
        this.setRequestHeader('Content-Type', 'application/json');
        this.setRequestBody(JSON.stringify(values));
    }

    parseResponseError(rawError) {
        return new ResponseError(rawError.message);
    }

    parseResponseResult(rawResult) {
        if (rawResult.error !== null) {
            return new ResponseResult(null, new ResponseError(rawResult.error.message));
        }

        return new ResponseResult(rawResult.data, null);
    }
}